import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const mapStateToProps = state => ({
  errorDisplay: state.error_page,
  form_settings: state.form_settings
});

const ErrorPage = ({ errorDisplay, form_settings }) => {
  if (!errorDisplay) {
    return null;
  }
  return (
    <div>
      <p>{form_settings.form_text.error_generated}</p>
    </div>
  );
};

ErrorPage.propTypes = {
  errorDisplay: PropTypes.bool.isRequired,
  //because dynamic change, not use shape
  form_settings: PropTypes.object.isRequired
};

export default connect(mapStateToProps)(ErrorPage);
